const rankingItems = [
  {
    rank: 1,
    title: '蜜桃视频 · 本月独家推荐 TOP1 精选合辑',
    tag: '蜜桃视频',
    heat: '🔥 32.6万',
    change: 'up',
    desc: '蜜桃视频本月最受关注的独家推荐内容，综合评分最高',
  },
  {
    rank: 2,
    title: '红桃视频 · 编辑力荐高分作品合集',
    tag: '红桃视频',
    heat: '🔥 28.1万',
    change: 'up',
    desc: '红桃视频编辑团队评选的本季高分作品精选合集',
  },
  {
    rank: 3,
    title: '香蕉视频 · VIP免费频道热门排行榜',
    tag: '香蕉视频',
    heat: '🔥 25.7万',
    change: 'up',
    desc: '香蕉视频VIP免费频道当前最热内容全收录',
  },
  {
    rank: 4,
    title: '樱花视频 · 新番速递人气排行',
    tag: '樱花视频',
    heat: '21.3万',
    change: 'down',
    desc: '樱花视频频道最新番剧人气排行榜实时更新',
  },
  {
    rank: 5,
    title: '日皮视频 · 独家策划专题系列',
    tag: '独家专题',
    heat: '18.9万',
    change: 'up',
    desc: '日皮视频团队独家策划的深度专题系列内容',
  },
  {
    rank: 6,
    title: '全站综合 · 本周热播 TOP 50',
    tag: '全站综合',
    heat: '15.4万',
    change: 'new',
    desc: '基于全站多维度数据综合计算的本周热播排行榜',
  },
];

export default function RankingSection() {
  return (
    <section id="ranking" className="py-16 md:py-20 bg-background-100">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-12 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-100 font-heading mb-3">
            热播排行榜
          </h2>
          <p className="text-sm text-foreground-500 max-w-[480px] mx-auto">
            基于全站热度、观看量与用户评分的综合排行榜，每日更新
          </p>
        </div>
        <div className="max-w-[900px] mx-auto space-y-3">
          {rankingItems.map((item) => (
            <div
              key={item.rank}
              className="flex items-center gap-4 md:gap-6 p-4 md:p-5 rounded-xl bg-background-50 border border-background-200/60 hover:border-primary-500/20 transition-all duration-200"
            >
              <div className="flex-shrink-0 w-10 h-10 md:w-12 md:h-12 flex items-center justify-center rounded-lg font-bold text-lg font-heading"
                style={{
                  backgroundColor:
                    item.rank === 1
                      ? 'oklch(var(--primary-500) / 0.2)'
                      : item.rank === 2
                      ? 'oklch(var(--accent-500) / 0.15)'
                      : item.rank === 3
                      ? 'oklch(var(--secondary-500) / 0.15)'
                      : 'oklch(var(--background-200))',
                  color:
                    item.rank === 1
                      ? 'oklch(var(--primary-500))'
                      : item.rank === 2
                      ? 'oklch(var(--accent-400))'
                      : item.rank === 3
                      ? 'oklch(var(--secondary-400))'
                      : 'oklch(var(--foreground-500))',
                }}
              >
                {item.rank}
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 mb-1">
                  <span className="text-xs font-medium px-2 py-0.5 rounded bg-accent-100/10 text-accent-300 whitespace-nowrap">
                    {item.tag}
                  </span>
                  {item.change === 'up' && (
                    <i className="ri-arrow-up-line text-xs text-green-400"></i>
                  )}
                  {item.change === 'down' && (
                    <i className="ri-arrow-down-line text-xs text-foreground-500"></i>
                  )}
                  {item.change === 'new' && (
                    <span className="text-xs text-primary-400 font-medium">NEW</span>
                  )}
                </div>
                <h3 className="text-sm md:text-base font-semibold text-foreground-100 font-heading truncate">
                  {item.title}
                </h3>
                <p className="text-xs text-foreground-600 mt-0.5 line-clamp-1">
                  {item.desc}
                </p>
              </div>
              <div className="flex-shrink-0 text-right">
                <span className="text-sm font-semibold text-primary-400 whitespace-nowrap">
                  {item.heat}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}